import { render, staticRenderFns } from "./DemoAd.vue?vue&type=template&id=661b4acb&scoped=true"
import script from "./DemoAd.vue?vue&type=script&lang=js"
export * from "./DemoAd.vue?vue&type=script&lang=js"
import style0 from "./DemoAd.vue?vue&type=style&index=0&id=661b4acb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661b4acb",
  null
  
)

export default component.exports